<template>
  <ModalCashRegister v-if="modalShowCashRegister" @closeModal="closeModal" :isOpen="isOpen"
    :label="isOpen ? 'Saldo Akhir' : 'Saldo Awal'" @refreshCashRegister="refreshCashRegister" :relevantCashRegister="relevantCashRegister" />
  <ModalImportMarketplace v-if="modalShowImportMarketplace" @closeModal="closeModalImportMarketplace" />
  <ModalImportTiktok v-if="modalShowImportTiktok" @closeModal="closeModalImportTiktok" />
  <ModalChooseCustomer v-if="modalShowCustomer" @closeModal="closeCustomerModal" @selectCustomer="createOrder" />
  <ModalProductStock v-if="modalShowProductStock" @closeModal="closeModalProductStock" />
  <ConfirmDialog group="headless">
        <template #container="{ message, acceptCallback, rejectCallback }">
            <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
                <div
                    class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
                    <i class="pi pi-question text-5xl"></i>
                </div>
                <span class="font-bold text-2xl block mb-2 mt-6">{{
                    message.header
                }}</span>
                <p class="mb-0">{{ message.message }}</p>
                <div class="flex items-center gap-2 mt-6">
                    <Button label="Save" @click="acceptCallback" class="w-32"></Button>
                    <Button label="Cancel" outlined @click="rejectCallback" class="w-32"></Button>
                </div>
            </div>
        </template>
    </ConfirmDialog>
  <div
    class="border-t-2 border-primary bg-light-50 dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg shadow-light-100 dark:shadow-dark-500">
    <!-- Header Section with Status -->
    <div class="relative p-6 border-b border-light-100 dark:border-dark-800">
      <div class="flex justify-between items-center">
        <div>
          <h2 class="text-3xl font-bold text-light-900 dark:text-dark-50">
            Cash Register
          </h2>
          <p class="text-base text-light-500 dark:text-dark-100 mt-1">
            Current Session Status
          </p>
          <button id="button-stock"
            class="bg-info text-light-50 px-4 py-2 text-base font-semibold rounded-lg shadow-md hover:opacity-90 transition-opacity duration-300 flex items-center gap-2 whitespace-nowrap dark:text-dark-50 hover:bg-hover-info"
            :disabled="!isOpen" :class="{ 'opacity-50 cursor-not-allowed': !isOpen }"
            @click="showModalProductStock" type="button">
            <i class="pi pi-box"></i> Stock
          </button>
        </div>
        <div class="flex flex-col items-end">
          <div class="text-2xl font-bold text-light-900 dark:text-dark-100">
            {{ stopwatch }}
          </div>
          <div class="mt-2 px-4 py-1.5 rounded-full text-sm font-semibold" :class="isOpen
            ? 'bg-success text-light-50 dark:text-dark-50'
            : 'bg-danger text-light-50 dark:text-dark-50'
            ">
            {{ isOpen ? "OPEN" : "CLOSED" }}
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="px-6 pb-6">
      <div v-if="!isOpen" class="text-center">
        <ExclamationCircleIcon class="h-20 w-20 text-gray-200 dark:text-gray-800 mx-auto" />
        <span class="text-gray-400 dark:text-gray-600">Cash Register Masih Belum Dimulai</span>
      </div>
      <!-- Saldo Section -->
      <div v-if="isOpen && isDetail" class="grid grid-cols-1 gap-6">
        <!-- Desktop View -->
        <div class="hidden sm:grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <div class="p-4 bg-light-200 dark:bg-dark-500 rounded-lg lg:col-span-1">
            <dt class="font-medium text-light-700 dark:text-dark-50">
              Saldo Awal
            </dt>
            <dd class="mt-2 text-2xl font-semibold text-light-700 dark:text-dark-50">
              {{
                formatRupiah(
                  initialBalance == undefined || initialBalance == null
                    ? 0
                    : initialBalance
                )
              }}
            </dd>
          </div>
          <div class="p-4 bg-light-200 dark:bg-dark-500 rounded-lg lg:col-span-1">
            <dt class="font-medium text-light-700 dark:text-dark-50">
              Total Transaksi
            </dt>
            <dd class="mt-2 text-2xl font-semibold text-light-700 dark:text-dark-50">
              {{ formatRupiah(totalTransaction) }}
            </dd>
          </div>
          <div class="p-4 bg-light-200 dark:bg-dark-500 rounded-lg">
            <dt class="font-medium text-light-700 dark:text-dark-50">
              Total Transaksi (Closed)
            </dt>
            <dd class="mt-2 text-2xl font-semibold text-light-700 dark:text-dark-50">
              {{ formatRupiah(totalClosedTransaction) }}
            </dd>
          </div>
          <div class="p-4 bg-light-200 dark:bg-dark-500 rounded-lg">
            <dt class="font-medium text-light-700 dark:text-dark-50">
              Jumlah Transaksi (Closed)
            </dt>
            <dd class="mt-2 text-2xl font-semibold text-light-700 dark:text-dark-50">
              {{ countClosedTransaction }}
            </dd>
          </div>
          <div class="p-4 bg-light-200 dark:bg-dark-500 rounded-lg">
            <dt class="font-medium text-light-700 dark:text-dark-50">
              Total Transaksi (Pending)
            </dt>
            <dd class="mt-2 text-2xl font-semibold text-light-700 dark:text-dark-50">
              {{ formatRupiah(totalPendingTransaction) }}
            </dd>
          </div>
          <div class="p-4 bg-light-200 dark:bg-dark-500 rounded-lg">
            <dt class="font-medium text-light-700 dark:text-dark-50">
              Jumlah Transaksi (Pending)
            </dt>
            <dd class="mt-2 text-2xl font-semibold text-light-700 dark:text-dark-50">
              {{ countPendingTransaction }}
            </dd>
          </div>
          <!-- <div class="p-4 bg-light-200 dark:bg-dark-500 rounded-lg">
            <dt class="font-medium text-light-700 dark:text-dark-50">
              Jumlah Kas Kecil (Deposit)
            </dt>
            <dd class="mt-2 text-2xl font-semibold text-light-700 dark:text-dark-50">
              {{ formatRupiah(totalDepositPettyCash) }}
            </dd>
          </div>
          <div class="p-4 bg-light-200 dark:bg-dark-500 rounded-lg">
            <dt class="font-medium text-light-700 dark:text-dark-50">
              Jumlah Kas Kecil (Withdrawal)
            </dt>
            <dd class="mt-2 text-2xl font-semibold text-light-700 dark:text-dark-50">
              {{ formatRupiah(totalWithdrawalPettyCash) }}
            </dd>
          </div> -->
        </div>

        <!-- Mobile View with Accordion -->
        <div class="sm:hidden space-y-4">
          <BaseAccordion>
            <template #header>
              <div>
                <dt class="text-sm font-medium text-light-700 dark:text-dark-50">
                  Jumlah Transaksi (closed)
                </dt>
                <dd class="text-lg font-semibold text-light-700 dark:text-dark-50 text-left">
                  {{ countClosedTransaction }}
                </dd>
              </div>
            </template>
            <template #content>
              <div class="space-y-4">
                <div class="flex flex-col items-start">
                  <span class="text-base font-medium text-light-700 dark:text-dark-50">Saldo Awal</span>
                  <span class="text-lg font-semibold text-light-700 dark:text-dark-50">{{
                    formatRupiah(
                      initialBalance == undefined || initialBalance == null
                        ? 0
                        : initialBalance
                    )
                  }}</span>
                </div>
                <div>
                  <dt class="text-sm font-medium text-light-700 dark:text-dark-50">
                    Total Transaksi
                  </dt>
                  <dd class="text-lg font-semibold text-light-700 dark:text-dark-50">
                    {{ formatRupiah(totalTransaction) }}
                  </dd>
                </div>
                <div class="flex flex-col items-start">
                  <span class="text-base font-medium text-light-700 dark:text-dark-50">Transaksi Selesai</span>
                  <span class="text-lg font-semibold text-light-700 dark:text-dark-50">{{
                    formatRupiah(totalClosedTransaction) }}</span>
                </div>
                <div class="flex flex-col items-start">
                  <span class="text-base font-medium text-light-700 dark:text-dark-50">Transaksi Pending</span>
                  <span class="text-lg font-semibold text-light-700 dark:text-dark-50">{{
                    formatRupiah(totalPendingTransaction) }}</span>
                </div>
                <div>
                  <dt class="text-sm font-medium text-light-700 dark:text-dark-50">
                    Jumlah Transaksi
                  </dt>
                  <dd class="text-lg font-semibold text-light-700 dark:text-dark-50">
                    {{ countPendingTransaction }}
                  </dd>
                </div>
                <!-- <div>
                  <dt class="text-sm font-medium text-light-700 dark:text-dark-50">
                    Jumlah Kas Kecil (Deposit)
                  </dt>
                  <dd class="text-lg font-semibold text-light-700 dark:text-dark-50">
                    {{ formatRupiah(totalDepositPettyCash) }}
                  </dd>
                </div>
                <div>
                  <dt class="text-sm font-medium text-light-700 dark:text-dark-50">
                    Jumlah Kas Kecil (Withdrawal)
                  </dt>
                  <dd class="text-lg font-semibold text-light-700 dark:text-dark-50">
                    {{ formatRupiah(totalWithdrawalPettyCash) }}
                  </dd>
                </div> -->
              </div>
            </template>
          </BaseAccordion>
        </div>
      </div>

      <!-- Footer Section -->
      <div class="mt-8 flex flex-col sm:flex-row justify-between sm:items-center gap-2">
        <button id="button-new-transaction"
          class="bg-green-700 dark:bg-green-700 text-light-50 px-4 py-3 text-base font-semibold rounded-lg shadow-md hover:opacity-90 transition-opacity duration-300 flex items-center gap-2 whitespace-nowrap dark:text-dark-50 hover:bg-hover-green-500 dark:hover:bg-hover-green-500"
          :disabled="!isOpen || isCreateProcessing" :class="{ 'opacity-50 cursor-not-allowed': !isOpen || isCreateProcessing }" @click="createOrder" >
          <ShoppingCartIcon class="h-5 w-5" />
          New Transaction
        </button>
        <!-- <div class="relative inline-block text-left">
          <button id="button-new-transaction"
            class="bg-info text-light-50 px-4 py-3 text-base font-semibold rounded-lg shadow-md hover:opacity-90 transition-opacity duration-300 flex items-center gap-2 whitespace-nowrap dark:text-dark-50 hover:bg-hover-info"
            :disabled="!isOpen" :class="{ 'opacity-50 cursor-not-allowed': !isOpen }"
            @click="dropdownOpen = !dropdownOpen" type="button">
            <i class="pi pi-upload"></i> Import <i v-if="dropdownOpen" class="pi pi-chevron-up"></i>
            <i v-else class="pi pi-chevron-down"></i>
          </button>
          <div v-if="dropdownOpen"
            class="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10">
            <div class="py-1">
              <button class="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100"
                @click="handleImportMarketplace" :disabled="!isOpen">
                Import Marketplace
              </button>
              <button class="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100"
                @click="handleImportTiktok" :disabled="!isOpen">
                Import TikTok
              </button>
            </div>
          </div>
        </div> -->

        <!-- Action Button -->
        <button v-if="!isOpen" id="button-open-register"
          class="bg-green-500 text-white px-4 py-3 text-base font-semibold rounded-lg shadow-md hover:bg-green-600 transition duration-300 flex items-center gap-2  whitespace-nowrap"
          @click="showModal">
          <ArrowRightOnRectangleIcon class="h-6 w-6" />
          Open Register
        </button>
        <button v-if="isOpen" id="button-close-register"
          class="bg-danger text-light-50 px-4 py-3 text-base font-semibold rounded-lg shadow-md hover:bg-secondary/90 transition duration-300 flex items-center gap-2  whitespace-nowrap dark:text-dark-50 hover:bg-hover-secondary"
          @click="showModal">
          <ArrowLeftOnRectangleIcon class="h-6 w-6" />
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { formatRupiah } from "@/helpers/formatRupiah";
import ModalCashRegister from "./modals/ModalCashRegister.vue";
import { mapActions, mapGetters } from "vuex";
import {
  ArrowRightOnRectangleIcon,
  ArrowLeftOnRectangleIcon,
  ShoppingCartIcon,
} from "@heroicons/vue/24/solid";
import { ExclamationCircleIcon } from "@heroicons/vue/24/outline";
import BaseAccordion from "@/components/base/BaseAccordion.vue";
import ModalImportMarketplace from "@/components/modals/ModalImportMarketplace.vue";
import ModalImportTiktok from "@/components/modals/ModalImportTiktok.vue";
import ModalChooseCustomer from "@/components/modals/ModalChooseCustomer.vue";
import { ConfirmDialog, Button } from "primevue";
import ModalProductStock from "@/components/modals/ModalProductStock.vue";

export default {
  name: "CashRegister",
  components: {
    ModalCashRegister, ArrowRightOnRectangleIcon, ArrowLeftOnRectangleIcon, ShoppingCartIcon, ExclamationCircleIcon, BaseAccordion, ModalImportMarketplace,
    ModalImportTiktok, ModalChooseCustomer, ConfirmDialog, Button, ModalProductStock
  },
  data() {
    return {
      modalShowCashRegister: false,
      modalShowProductStock: false,
      isBlur: false,
      stopwatch: "00:00:00",
      elapsed: "00:00:00",
      startTime: null,
      difference: 0,
      allCashRegisters: [],
      modalShowImportMarketplace: false,
      modalShowImportTiktok: false,
      product: null,
      dropdownOpen: false,
      modalShowCustomer: false,
      isCreateProcessing: false,
    };
  },
  computed: {
    ...mapGetters("sales_orders", ["allSalesOrders"]),
    ...mapGetters("petty_cash", ["allPettyCashes"]),
    relevantCashRegister() {
      return this.allCashRegisters.find((cr) => cr.status == "open");
    },
    isDetail() {
      const isAllowed = ["1", "2"];
      return localStorage.getItem("role_id") == "null" || isAllowed.includes(localStorage.getItem("role_id"));
    },
    totalDepositPettyCash() {
      return this.allPettyCashes.reduce((sum, pc) => sum + (this.relevantCashRegister.id == pc.cash_register_id && pc.amount_deposit ? parseFloat(pc.amount_deposit) : 0), 0);
    },
    totalWithdrawalPettyCash() {
      return this.allPettyCashes.reduce((sum, pc) => sum + (this.relevantCashRegister.id == pc.cash_register_id && pc.amount_withdrawal ? parseFloat(pc.amount_withdrawal) : 0), 0);
    },
    initialBalance() {
      return this.relevantCashRegister?.start_saldo;
    },
    endBalance() {
      return this.relevantCashRegister?.end_saldo;
    },
    isOpen() {
      return (
        this.relevantCashRegister != null &&
        this.relevantCashRegister != undefined
      );
    },
    totalTransaction() {
      const salesOrders = [...this.allSalesOrders];
      return salesOrders.reduce((sum, item) => {
        const grandTotal = parseFloat(item.grand_total);
        let addition =
          grandTotal == undefined || grandTotal == null ? 0 : grandTotal;
        return sum + addition;
      }, 0);
    },
    totalClosedTransaction() {
      const salesOrders = [...this.allSalesOrders];
      return salesOrders
        .filter((so) => so.status == "paid")
        .reduce((sum, item) => {
          const grandTotal = parseFloat(item.grand_total);
          let addition =
            grandTotal == undefined || grandTotal == null ? 0 : grandTotal;
          return sum + addition;
        }, 0);
    },
    countClosedTransaction() {
      const salesOrders = [...this.allSalesOrders];
      return salesOrders.filter((so) => so.status == "paid").length;
    },
    totalPendingTransaction() {
      const salesOrders = [...this.allSalesOrders];
      return salesOrders
        .filter((so) => so.status == "pending")
        .reduce((sum, item) => {
          const grandTotal = parseFloat(item.grand_total);
          let addition =
            grandTotal == undefined || grandTotal == null ? 0 : grandTotal;
          return sum + addition;
        }, 0);
    },
    countPendingTransaction() {
      const salesOrders = [...this.allSalesOrders];
      return salesOrders.filter((so) => so.status == "pending").length;
    },
  },
  created() {
    this.refreshCashRegister();
  },
  methods: {
    ...mapActions("cash_registers", [
      "createCashRegister",
      "closeCashRegister",
    ]),
    ...mapActions("petty_cash", ["fetchPettyCashes"]),
    ...mapActions("sales_orders", ["createSalesOrder"]),
    formatRupiah,
    handleImportMarketplace() {
      this.dropdownOpen = false;
      this.showModalImportMarketplace();
    },
    handleImportTiktok() {
      this.dropdownOpen = false;
      this.showModalImportTiktok();
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
      }).format(value);
    },
    startStopwatch() {
      let seconds = this.isOpen
        ? Math.floor(
          (new Date() - new Date(this.relevantCashRegister.time_start)) / 1000
        )
        : 0;
      this.timeInterval = setInterval(() => {
        seconds++;
        const hrs = String(Math.floor(seconds / 3600)).padStart(2, "0");
        const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
        const secs = String(seconds % 60).padStart(2, "0");
        this.stopwatch = `${hrs}:${mins}:${secs}`;

        // Update Elapsed Time
        if (this.isOpen) {
          this.elapsed = `${hrs}:${mins}:${secs}`;
        }
      }, 1000);
    },
    stopStopwatch() {
      clearInterval(this.timeInterval);
      this.stopwatch = "00:00:00";
    },
    showModal() {
      this.modalShowCashRegister = true;
      this.isBlur = true;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowCashRegister = false;
        this.isBlur = false;
      }, 200);
    },
    showModalProductStock() {
      this.modalShowProductStock = true;
      this.isBlur = true;
    },
    closeModalProductStock() {
      setTimeout(() => {
        this.modalShowProductStock = false;
        this.isBlur = false;
      }, 200);
    },
    async refreshCashRegister() {
      this.allCashRegisters = [];
      try {
        this.stopStopwatch();
        await this.fetchPettyCashes();

        const response = await this.$store.dispatch(
          "cash_registers/fetchOpenCashRegisters"
        );
        if (response) {
          this.allCashRegisters = response.data;
        }
        if (this.isOpen) {
          this.$store.dispatch("sales_orders/fetchSalesOrders", { limit: 1000, cash_register_id: this.relevantCashRegister.id });
          this.startStopwatch();
        }
      } catch (error) {
        console.log(error);
        this.allCashRegisters = [];

        this.$toast.add({
          severity: "error",
          summary: "Failed",
          detail: error.response.data.message,
          life: 5000,
        });
      }
    },
    createNewTransaction() {
      this.$router.push({ name: "order" });
    },
    closeCustomerModal() {
      this.modalShowCustomer = false;
      console.log(this.transaction);
    },
    showModalCustomer() {
      this.modalShowCustomer = true;
    },
    async createOrder() {
      try {
        this.isCreateProcessing = true;
        const response = await this.createSalesOrder({
          table_id: null,
          marketing_id: null,
          cash_register_id: this.relevantCashRegister.id,
          transaction_type_id: 1,
          customer_name: "",
          customer_phone: "",
          customer_id: null,
          sub_total: 0,
          grand_total: 0,
          status: "pending",
          order_type: 'take_away',
          payment_amount: 0,
          payment_change: 0,
          tax: 0,
          service_charge: 0,
          discount: 0,
          note: "",
        });

        const orderId = response.data.id;

        this.$router.push({
          name: "order",
          query: {
            orderId
          },
        });
      } catch (error) {
        console.error("Error processing order:", error);
        alert("Terjadi kesalahan saat memproses pesanan");

        if (this.selectedTableId) {
          try {
            await this.updateTable({
              id: this.selectedTableId,
              status: "available",
            });
          } catch (revertError) {
            console.error("Error reverting table status:", revertError);
          }
        }
      } finally {
        this.isCreateProcessing = false;
      }
    },
    showModalImportMarketplace() {
      this.modalShowImportMarketplace = true;
    },
    closeModalImportMarketplace() {
      this.modalShowImportMarketplace = false;
    },
    showModalImportTiktok() {
      this.modalShowImportTiktok = true;
    },
    closeModalImportTiktok() {
      this.modalShowImportTiktok = false;
    },
    emit: ["show-dialog"],
  },
};
</script>

<style>
body {
  font-family: "Inter", sans-serif;
}
</style>
